import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tab-table',
  templateUrl: './tab-table.component.html',
  styleUrls: ['./tab-table.component.css']
})
export class TabTableComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
